import { render, staticRenderFns } from "./PaymentTypeCard.vue?vue&type=template&id=6b6b66e0&scoped=true"
import script from "./PaymentTypeCard.vue?vue&type=script&lang=js"
export * from "./PaymentTypeCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeCard.vue?vue&type=style&index=0&id=6b6b66e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b66e0",
  null
  
)

export default component.exports